const digitRegExp = /[0-9A-Za-z]/;

export function AlphanumberMask(value: string = '') {
  return value.split('').map(char => {
    if (digitRegExp.test(char)) {
      return digitRegExp;
    }
  });
}
